module.exports = __webpack_public_path__ + "images/btn_remove---6f0884ca8719e38e73567d77d98e845e.png";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/style/img/cart/btn_remove.png
// module id = 398
// module chunks = 0